import {
    IPurchasingGroupBlockingAssignmentDto,
    IPurchasingGroupCompanyCodeRemovalBlockedDto,
} from '../types/purchasing-group-company-code-removal-blocked.dto';

export class PurchasingGroupBlockingAssignment {
    public readonly companyCodeId: string;
    public readonly materialGroupId: string;

    constructor(dto: IPurchasingGroupBlockingAssignmentDto) {
        this.companyCodeId = dto.companyCodeId;
        this.materialGroupId = dto.materialGroupId;
    }
}

export class PurchasingGroupCompanyCodeRemovalBlocked {
    public readonly message: string;
    public readonly purchasingGroupId: string;
    public readonly blockingAssignments: readonly PurchasingGroupBlockingAssignment[];

    constructor(dto: IPurchasingGroupCompanyCodeRemovalBlockedDto) {
        this.message = dto.message;
        this.purchasingGroupId = dto.purchasingGroupId;
        this.blockingAssignments = (dto.blockingAssignments ?? []).map(
            (assignment) => new PurchasingGroupBlockingAssignment(assignment),
        );
    }
}
